// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-password-password-strength-password-strength-styles__Too-weak {
  color: #ff345e;
}

.src-password-password-strength-password-strength-styles__Fair {
  color: #ff345e;
}

.src-password-password-strength-password-strength-styles__Medium {
  color: #ec8144;
}

.src-password-password-strength-password-strength-styles__condensedFontToFit {
  line-height: 14px;
  padding-top: 2px;
  position: absolute;
}
`, "",{"version":3,"sources":["webpack://./src/password/password-strength/password-strength.styles.css"],"names":[],"mappings":"AAAA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB","sourcesContent":[".Too-weak {\n  color: #ff345e;\n}\n\n.Fair {\n  color: #ff345e;\n}\n\n.Medium {\n  color: #ec8144;\n}\n\n.condensedFontToFit {\n  line-height: 14px;\n  padding-top: 2px;\n  position: absolute;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Too-weak": `src-password-password-strength-password-strength-styles__Too-weak`,
	"Fair": `src-password-password-strength-password-strength-styles__Fair`,
	"Medium": `src-password-password-strength-password-strength-styles__Medium`,
	"condensedFontToFit": `src-password-password-strength-password-strength-styles__condensedFontToFit`
};
export default ___CSS_LOADER_EXPORT___;
